export type DetailScope = "overview" | "response";

export const generateDetailLink = ({
  scope,
  params,
  overviewFilters,
  responseFilters,
  selectedAssignmentGroupNames,
  selectedFieldEngineers,
  selectedRegions,
  selectedAccounts,
}: {
  scope: DetailScope;
  params: {
    status?: string;
    pageNumber?: string;
    pageRowCount?: string;
    searchCriteria?: string;
    eventType?: string | null;
    isBreached?: boolean | null;
    isAboutToBreach?: boolean | null;
    title?: string;
    sourceDashboard?: string;
    isSiteNotAccessible?: boolean;
    assignmentGroup?: string;
    customerId?: string;
    activityType?: string;
  };
  overviewFilters: { date?: { id?: string } };
  responseFilters: { date?: { id?: string } };
  selectedAssignmentGroupNames: string[];
  selectedFieldEngineers: { employeeId: string }[];
  selectedRegions: { name: string }[];
  selectedAccounts: { customerId: string }[];
}) => {
  const query = new URLSearchParams({
    status: String(params.status ?? ""),
    pageNumber: String(params.pageNumber ?? "1"),
    pageRowCount: String(params.pageRowCount ?? "100"),
    searchCriteria: String(params.searchCriteria ?? ""),
    eventCategory: "SLA",
    eventType: String(params.eventType ?? null),
    isBreached: String(params.isBreached ?? null),
    isAboutToBreach: String(params.isAboutToBreach ?? null),
    title: String(params.title ?? ""),
    sourceDashboard: String(params.sourceDashboard ?? ""),
  });

  if (params.isSiteNotAccessible === true) {
    query.set("isSiteNotAccessible", "true");
  }

  if (scope === "overview") {
    query.set("period", overviewFilters.date?.id ?? "all");

    query.set(
      "assignmentGroup",
      params.assignmentGroup ??
        (selectedAssignmentGroupNames.length
          ? selectedAssignmentGroupNames.join(",")
          : ""),
    );

    if (
      selectedFieldEngineers.length &&
      !selectedFieldEngineers.some((f) => f.employeeId === "all")
    ) {
      query.set(
        "fieldEngineer",
        selectedFieldEngineers.map((f) => f.employeeId).join(","),
      );
    }
    if (selectedRegions.length) {
      query.set("regions", selectedRegions.map((r) => r.name).join(","));
    }

    if (selectedAccounts.length) {
      query.set(
        "customerId",
        selectedAccounts.map((c) => c.customerId).join(","),
      );
    }
  }

  if (scope === "response") {
    query.set("period", responseFilters.date?.id ?? "all");

    if (params.customerId) {
      query.set("customerId", String(params.customerId));
    }

    if (params.activityType) {
      query.set("activityType", String(params.activityType));
    }
  }

  return `/sla-dashboard-detail?${query.toString()}`;
};
